// facebookService.js

import facebookConfig from './FacebookConfig';

// Đăng ký sớm nhất có thể (trước React overlay) để chặn lỗi nội bộ của Facebook SDK
const _suppressFBSDKError = event => {
  const src =
    event?.filename || event?.reason?.stack || event?.reason?.message || '';
  const msg = event?.message || event?.reason?.message || '';
  const combined = src + ' ' + msg;
  if (
    combined.includes('connect.facebook.net') ||
    combined.includes('facebook.com/') ||
    combined.includes('ModuleError') ||
    combined.includes('unresolved dependencies')
  ) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    return true;
  }
};
const _suppressFBSDKRejection = event => {
  const src = event?.reason?.stack || event?.reason?.message || '';
  const msg = event?.reason?.message || '';
  const combined = src + ' ' + msg;
  if (
    combined.includes('connect.facebook.net') ||
    combined.includes('facebook.com/') ||
    combined.includes('ModuleError') ||
    combined.includes('unresolved dependencies')
  ) {
    event.preventDefault();
  }
};
window.addEventListener('error', _suppressFBSDKError, true);
window.addEventListener('unhandledrejection', _suppressFBSDKRejection, true);

class FacebookService {
  constructor() {}
  // Cấu hình

  // Khởi tạo Facebook SDK
  init() {
    return new Promise((resolve, reject) => {
      // Nếu SDK đã được load và khởi tạo rồi thì resolve ngay
      if (window.FB) {
        resolve();
        return;
      }

      // Suppress lỗi nội bộ của Facebook SDK (ModuleError, unresolved dependencies)
      // SDK gọi console.error nội bộ + throw window error + unhandledrejection
      const isFBSDKMsg = (...args) => {
        const str = args.map(a => String(a ?? '')).join(' ');
        return (
          str.includes('connect.facebook.net') ||
          str.includes('facebook.com/') ||
          str.includes('ModuleError') ||
          str.includes('unresolved dependencies')
        );
      };

      // Override console.error để lọc lỗi FB SDK
      const _originalConsoleError = console.error;
      console.error = (...args) => {
        if (isFBSDKMsg(...args)) return;
        _originalConsoleError.apply(console, args);
      };

      const isFBSDKEvent = event => {
        const src =
          event?.filename ||
          event?.reason?.stack ||
          event?.reason?.message ||
          '';
        const msg = event?.message || event?.reason?.message || '';
        return isFBSDKMsg(src, msg);
      };

      const fbErrorHandler = event => {
        if (isFBSDKEvent(event)) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation(); // Chặn React dev overlay listener
          return true;
        }
      };

      const fbRejectionHandler = event => {
        if (isFBSDKEvent(event)) {
          event.preventDefault();
        }
      };

      const restoreConsole = () => {
        console.error = _originalConsoleError;
      };

      window.addEventListener('error', fbErrorHandler, true);
      window.addEventListener('unhandledrejection', fbRejectionHandler, true);

      // Timeout fallback: nếu SDK không khởi tạo được sau 10s thì resolve (không blocking)
      const timeout = setTimeout(() => {
        window.removeEventListener('error', fbErrorHandler, true);
        window.removeEventListener(
          'unhandledrejection',
          fbRejectionHandler,
          true
        );
        restoreConsole();
        resolve(); // resolve thay vì reject để không crash app
      }, 10000);

      // Load SDK script
      window.fbAsyncInit = function () {
        clearTimeout(timeout);
        window.removeEventListener('error', fbErrorHandler, true);
        window.removeEventListener(
          'unhandledrejection',
          fbRejectionHandler,
          true
        );
        restoreConsole();
        try {
          window.FB.init(facebookConfig);
          resolve();
        } catch (err) {
          reject(err);
        }
      };

      // Tạo script tag (nếu chưa có)
      (function (document, name, id) {
        if (document.getElementById(id)) {
          // Script tag đã tồn tại nhưng FB chưa ready → đợi fbAsyncInit
          return;
        }
        const fjs = document.getElementsByTagName(name)[0];
        const js = document.createElement(name);
        js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk.js';
        js.onerror = () => {
          clearTimeout(timeout);
          window.removeEventListener('error', fbErrorHandler, true);
          window.removeEventListener(
            'unhandledrejection',
            fbRejectionHandler,
            true
          );
          restoreConsole();
          reject(
            new Error(
              'Không thể tải Facebook SDK. Vui lòng kiểm tra kết nối hoặc tắt trình chặn quảng cáo.'
            )
          );
        };
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
    });
  }

  // // Kiểm tra trạng thái đăng nhập
  // getLoginStatus() {
  //   return new Promise((resolve) => {
  //     window.FB.getLoginStatus((response) => {
  //       resolve(response);
  //     });
  //   });
  // },

  loginWithCode(redirectUri = window.location.origin) {
    const appId = facebookConfig.appId; // Thay bằng App ID của bạn
    const scope = facebookConfig.defaultScope;

    const authUrl =
      `https://www.facebook.com/v18.0/dialog/oauth?` +
      `client_id=${appId}` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}` +
      `&scope=${encodeURIComponent(scope)}` +
      `&response_type=code` +
      `&state=xyz123`;

    window.location.href = authUrl;
  }

  // Đăng nhập
  login(
    options = {
      scope: 'public_profile,email',
      response_type: 'code',
    }
  ) {
    return new Promise(resolve => {
      window.FB.login(response => {
        resolve(response);
      }, options);
    });
  }

  // Đăng xuất
  logout() {
    return new Promise(resolve => {
      window.FB.logout(response => {
        resolve(response);
      });
    });
  }

  // // Lấy thông tin user
  // getUserInfo(fields = "id,name,email,picture") {
  //   return new Promise((resolve, reject) => {
  //     window.FB.api("/me", { fields }, (response) => {
  //       if (response.error) {
  //         reject(response.error);
  //       } else {
  //         resolve(response);
  //       }
  //     });
  //   });
  // },

  // // Gọi Graph API
  // api(path, params = {}) {
  //   return new Promise((resolve, reject) => {
  //     window.FB.api(path, params, (response) => {
  //       if (response.error) {
  //         reject(response.error);
  //       } else {
  //         resolve(response);
  //       }
  //     });
  //   });
  // },

  // // Lấy Access Token
  // getAccessToken() {
  //   return new Promise((resolve) => {
  //     window.FB.getLoginStatus((response) => {
  //       if (response.status === "connected") {
  //         resolve(response.authResponse.accessToken);
  //       } else {
  //         resolve(null);
  //       }
  //     });
  //   });
  // },

  // // Kiểm tra SDK đã load chưa
  // isSDKLoaded() {
  //   return typeof window.FB !== "undefined";
  // },
}

// Tạo instance singleton
const facebookService = new FacebookService();

export default facebookService;
